import { SpinnerOutlineIcon, SvgIconProps } from '@applyboard/ui-icons';
import { keyframes } from '@emotion/react';
import { a11y } from '~/design';
import { IconWrapper } from '~/internal';

export interface SpinnerProps {
  size?: SvgIconProps['size'];
}

export function Spinner({ size = 'md' }: SpinnerProps) {
  return (
    <span
      css={{
        animationDirection: 'normal',
        animationDuration: '0.8s',
        animationIterationCount: 'infinite',
        animationName: loadingAnimation,
        animationTimingFunction: 'linear',
        display: 'inline-block',
        lineHeight: 0,
      }}
    >
      <span css={a11y.srOnly}>Loading</span>
      <IconWrapper allowInteractions={false} intent="primary" selector="span">
        <SpinnerOutlineIcon size={size} />
      </IconWrapper>
    </span>
  );
}

const loadingAnimation = keyframes`
  0% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(270deg);
  }
`;
